import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-read',
  templateUrl: './program-read.component.html',
  styleUrls: ['./program-read.component.css']
})
export class ProgramReadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-new/program/program-read/program-read.component.ts